import React from "react";
import "./About.css";
import img1 from "../Images/about1.png";
import img2 from "../Images/about2.png";

const About = () => {
  return (
    <div className="divWrapper" id="about">
      <div className="arvrcontainer aboutContainer">
        <div className="about-left">
          <div className="about-img">
            <img src={img1} alt="about-img" className="innerImage" />
          </div>
          <div className="about-img secondAboutImg">
            <img src={img2} alt="about-img" className="innerImage" />
          </div>
        </div>
        <div className="about-right">
          <div className="about-title">
            <span className="before-line"></span>
            <h2 className="heading">About Us</h2>
          </div>
          {/* <p className="about-text-firstp">
            At <strong style={{color: "#000"}}>BastionEx</strong>, we don’t just build software — we engineer digital
            breakthroughs.
          </p>
          <p>
            We're a future-focused technology company delivering <strong style={{color: "#000"}}> cutting-edge
            software development, blockchain integration, and immersive AR/VR
            solutions </strong> across multiple industries. With deep expertise and a
            commitment to innovation, we help businesses step confidently into
            the next generation of digital transformation.
          </p>
          <p>
            From secure smart contracts to immersive training simulations,
            BastionEx is where powerful code meets visionary experience design.
          </p> */}
          <p>
            Step into the future with our state-of-the-art <span className="strong">AR VR development
            services.</span> We bring your vision to life with immersive, interactive
            experiences that engage users and deliver real results. Whether
            you're developing a next-generation <span className="strong">virtual reality application</span>,
            rolling out meaningful <span className="strong"> augmented reality projects</span>, or pushing the
            boundaries of <span className="strong">AR/VR Technology</span>, we're the team to help you bring
            your vision to reality.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
